// extracted by mini-css-extract-plugin
module.exports = {"description":"WncCi","rtl-fix":"NTPd3","rtlFix":"NTPd3"};